<template>
    <div class="splashBody" v-if="showSplash">
      <div class="splashScreen">
        <div class="loadingContainer">
          <div class="loadingBox">
            <img src="@/assets/ReuniteIcon2024v2.png">
            <div class="loadingBarContainer">
              <div class="loadingbar"></div>
            </div>
            <div class="loadingCircle">
              <div class="circleOuter"></div>
              <div class="circleLoader"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="splashBehind"></div>
      <!-- <div class="splashBehindTwo"></div> -->
      <notifications ref="notifications"></notifications>
    </div>
  </template>
  
  <script>
  import Notifications from './Notification.vue';
  import codeCompleteAudio from "../assets/audio/Notification2.wav";
  import codeCompleteAudio2 from "../assets/audio/ThinClick.wav";
  
  export default {
    components: {
      Notifications
    },
    data() {
      return {
        showSplash: true,
      };
    },
    mounted() {
      this.startLoading();
    },
    methods: {
      startLoading() {
        setTimeout(() => {
          this.notifyAndSpeak('Activating Detective Nodes');
        }, 1000);
  
        setTimeout(() => {
          this.notifyAndSpeak2('Research');
        }, 2000);
  
        setTimeout(() => {
          this.notifyAndSpeak2('Knowledge');
        }, 4000);
  
        setTimeout(() => {
          this.notifyAndSpeak2('Case Management');
        }, 6000);
  
        setTimeout(() => {
          this.animateLoadingBar();
        }, 3000);
  
        setTimeout(() => {
          this.animateLoadingBox();
        }, 1000);
  
        setTimeout(() => {
          this.animateSplashScreen();
        }, 8000);
  
        setTimeout(() => {
          this.animateLoadingCircle();
        }, 8000);
  
        setTimeout(() => {
          this.showSplash = false;
          document.body.classList.add('visibleSplash');
          this.playSoundAndSpeak('AI Detective is ready');
        }, 8500);
      },
      notifyAndSpeak(message) {
        this.$refs.notifications.addNotification(message, 'info');
        this.readOutLoud(message);
      },
      notifyAndSpeak2(message) {
        this.$refs.notifications.addNotification(message, 'info');
        this.readOutLoud(message);
        setTimeout(() => {
          const audio = new Audio(codeCompleteAudio2);
          audio.volume = 0.5;  // Set volume to 50%
          audio.play();
        }, 1800);
      },
      playSoundAndSpeak(message) {
        this.readOutLoud(message);
        this.$refs.notifications.addNotification(message, 'success');
        setTimeout(() => {
          const audio = new Audio(codeCompleteAudio);
          audio.volume = 0.25;  // Set volume to 50%
          audio.play();
        }, 3000);
      },
      readOutLoud(msg) {
        const speech = new SpeechSynthesisUtterance();
        const voiceName = 'Google UK English Female';
        speech.volume = 1;
        speech.rate = 1;
        speech.pitch = 1;
        speech.voice = speechSynthesis.getVoices().find(voice => voice.name === voiceName);
        speech.text = msg;
        window.speechSynthesis.speak(speech);
      },
      animateLoadingBar() {
        const loadingBar = document.querySelector('.loadingbar');
        loadingBar.style.transition = 'left 6s';
        loadingBar.style.left = '0';
      },
      animateLoadingBox() {
        const loadingBox = document.querySelector('.loadingBox');
        loadingBox.style.transition = 'opacity 1s';
        loadingBox.style.opacity = '1';
      },
      animateSplashScreen() {
        const splashScreen = document.querySelector('.splashScreen');
        splashScreen.style.transition = 'top 6s';
        splashScreen.style.top = '-100%';
      },
      animateLoadingCircle() {
        const loadingCircle = document.querySelector('.loadingCircle');
        loadingCircle.style.transition = 'opacity 0.5s';
        loadingCircle.style.opacity = '0';
      },
    },
  };
  </script>
  
  <style scoped>
  body {
    overflow: hidden;
  }
  
  body.visibleSplash {
    overflow: visible !important;
  }
  
  .splashScreen {
    width: 100%;
    height: 90vh;
    position: absolute;
    top: 0;
    left: 0;
    background: #ffffff00;
    border-bottom: 5px solid #333;
    overflow: hidden;
  }
  
  .loadingContainer {
    width: 400px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    overflow: hidden;
  }
  
  .loadingBox {
    width: 100%;
    height: 100%;
    opacity: 0;
  }
  
  .splashLogo {
    width: 50%;
    margin: 0 0 50px;
  }
  
  .loadingBarContainer {
    width: 100%;
    background: #e1dcdc;
    height: 10px;
    display: block;
    margin: 50px 0 0;
    overflow: hidden;
  }
  
  .loadingbar {
    width: 100%;
    height: 10px;
    background: #579a3ae5;
    position: absolute;
    left: -100%;
  }
  
  .loadingCircle {
    width: 75px;
    height: 75px;
    margin: 30px auto 0;
    background: #fff;
    display: block;
    border-radius: 50%;
    position: relative;
    overflow: hidden;
  }
  
  .circleOuter {
    width: 60px;
    height: 60px;
    background: #fff;
    border-radius: 50%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
  }
  
  .circleLoader {
    width: 75px;
    height: 75px;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 1) 0%, rgba(125, 185, 232, 0) 100%);
    position: absolute;
    right: 50%;
    bottom: 50%;
    transform-origin: bottom right;
    z-index: 1;
    animation: rotateLoader 1.5s linear infinite;
  }
  
  @keyframes rotateLoader {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  
  .splashBehind {
    background: rgba(193, 180, 180, 0);
    width: 100%;
    height: 90vh;
  }
  
  .splashBehindTwo {
    background: #000000;
    width: 0;
    height: 0;
  }
  </style>
  